// @ts-nocheck
import { getCmsLibrary, GetCmsLibraryApiParameter } from "@store/Framework/Services/CmsLibraryService";
import { CmsLibraryModel } from "@store/Framework/Types/ApiModels";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface LoadCmsLibraryResult {
    apiResult: CmsLibraryModel;
}

type HandlerType = Handler<GetCmsLibraryApiParameter, LoadCmsLibraryResult>;

export const getCmsLibrarySessionKey = (libraryType: string) => `cmsLibrarySearchWithin_${libraryType}`;

let currentRequestId = 0;

export const DispatchBeginLoadCmsLibrary: HandlerType = props => {
    props.dispatch({
        type: "Data/CmsLibrary/BeginLoadCmsLibrary",
    });
};

export const ResetParameters: HandlerType = props => {
    if (props.parameter.isFirstLoad) {
        props.dispatch({
            type: "Data/CmsLibrary/ResetParameters",
        });
    }
};

export const RequestDataFromApi: HandlerType = async props => {
    const thisRequestId = ++currentRequestId;

    const savedSearch = props.parameter.isFirstLoad
        ? (sessionStorage.getItem(getCmsLibrarySessionKey(props.parameter.libraryType)) ?? "")
        : "";

    const effectiveParameter: GetCmsLibraryApiParameter = savedSearch
        ? { ...props.parameter, search: savedSearch }
        : props.parameter;

    try {
        props.apiResult = await getCmsLibrary(effectiveParameter);

        if (thisRequestId !== currentRequestId) {
            return false;
        }
    } catch (error) {
        if ("status" in error && error.status === 404) {
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteLoadCmsLibrary: HandlerType = ({ dispatch, apiResult, parameter }) => {
    dispatch({
        type: "Data/CmsLibrary/CompleteLoadCmsLibrary",
        result: apiResult,
        currentType: parameter.libraryType,
    });
};

export const chain = [DispatchBeginLoadCmsLibrary, ResetParameters, RequestDataFromApi, DispatchCompleteLoadCmsLibrary];

const loadCmsLibraryData = createHandlerChainRunner(chain, "LoadCmsLibraryData");
export default loadCmsLibraryData;
